export default __webpack_public_path__ + "static/media/threat_analy2.db80f83c.png";